<template>
  <audio ref="audio" v-bind:title="current_track.text" />
</template>

<script>
import getLogarithmicVolume from "@/plugins/GetLogarithmicVolume.js";
import { mapState } from "vuex";
import { SET_IS_PLAYING } from "@/store/mutation-types";
import toast from "@/plugins/toast";
export default {
  data() {
    return {
      audio: null,
      duration: 0,
      currentTime: 0,
    };
  },
  mounted() {
    // Allow pausing from the mobile metadata update.
    if ("mediaSession" in navigator) {
      navigator.mediaSession.setActionHandler("pause", () => {
        this.stop();
      });
    }

    // Check the query string if browser supports easy query string access.
    if (typeof URLSearchParams !== "undefined") {
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("volume")) {
        this.volume = parseInt(urlParams.get("volume"));
      }
    }

    this.$eventHub.$on("player_toggle", () => {
      this.toggle(this.station.listen_url);
    });

     this.$eventHub.$on("player_stopped", () => {
      this.stop();
    });
  },

  computed: mapState(["volume"]),

  watch: {
    volume(volume) {
      if (this.audio !== null) {
        this.audio.volume = getLogarithmicVolume(volume);
      }
    },
  },
  methods: {
    stop() {
      if (this.audio !== null) {
       // this.$eventHub.$emit("player_stopped", this.audio.src);

        this.audio.pause();
        this.audio.src = "";
      }

      this.duration = 0;
      this.currentTime = 0;

      this.$store.commit(SET_IS_PLAYING, false);
    },
    play(url) {
      if (this.isPlaying()) {
        this.stop();
        this.$nextTick(() => {
          this.play(url);
        });
        return;
      }

      this.audio = this.$refs.audio;

      this.audio.onerror = (e) => {
        if (
          e.target.error.code === e.target.error.MEDIA_ERR_NETWORK &&
          this.audio.src !== ""
        ) {
          console.log(
            "Network interrupted stream. Automatically reconnecting shortly..."
          );
          setTimeout(() => {
            this.play(url);
          }, 5000);
        }
      };

      this.audio.onended = () => {
        this.stop();
      };

      this.audio.ontimeupdate = () => {
        this.duration =
          this.audio.duration !== Infinity && !isNaN(this.audio.duration)
            ? this.audio.duration
            : 0;
        this.currentTime = this.audio.currentTime;
      };

      this.audio.volume = getLogarithmicVolume(this.volume);

      this.audio.src = url;

      this.audio.load();
      this.audio.play();

      this.$eventHub.$emit("player_playing", url);
      this.$store.commit(SET_IS_PLAYING, true);
    },
    toggle(url) {
      this.$nextTick( ()=>{
        if (!this.onAir) {
       toast.error('Station is offline... ', 'error', 'center-start')
        this.stop();
        return;
      }
      })
      

      if (
        this.isPlaying() &&
        this.getUrlWithoutQuery(this.audio.src) === this.getUrlWithoutQuery(url)
      ) {
        this.stop();
      } else {
        this.stop();
        this.$nextTick(() => {
          this.play(url);
        });
      }
    },
    isPlaying() {
      return this.$store.state.isPlaying;
    },
    getVolume() {
      return this.volume;
    },
    setVolume(vol) {
      this.volume = vol;
    },
    getCurrentTime() {
      return this.currentTime;
    },
    getDuration() {
      return this.duration;
    },
    getProgress() {
      return this.duration !== 0
        ? Math.round((this.currentTime / this.duration) * 100, 2)
        : 0;
    },
    setProgress(progress) {
      if (this.audio !== null) {
        this.audio.currentTime = (progress / 100) * this.duration;
      }
    },
    getUrlWithoutQuery(url) {
      return url.split(/[?#]/)[0];
    },
  },
};
</script>
